import React from "react";
import PageHeaderLayout from "../../../../layout/pageHeaderLayout";
import useAntTable from "../../../../utils/useAntTable";
import * as api from "../../../../apis/dealer"
import StandardTable, {StandardColumnsType} from "../../../../components/StandardTable";
import useAuth from "../../../../utils/useAuth";

export default function DealerCreditStatistics() {

    const {tableProps, search, form, refresh} = useAntTable(api.getDealerCreditStatisticsList, {})

    const showTemporary = useAuth().indexOf('fieldTemporaryCreditLimitView') > -1;

    const columns: StandardColumnsType = [
        {title: '客户编号', dataIndex: 'dealerCode'},
        {title: '客户名称', dataIndex: 'dealerName'},
        {title: '信用额度', dataIndex: 'creditLimit'},
        ...(showTemporary ? [{title: '临时信用额度', dataIndex: 'temporaryCreditLimit'}] : []),
        {title: '订单总金额', dataIndex: 'dealerOrderTotalAmount'},
        {title: '已付款金额', dataIndex: 'dealerPaidAmountTotal'},
        {title: '未付款金额', dataIndex: 'dealerNoPaidAmountTotal'},
        {title: '退款未核销', dataIndex: 'dealerRefundNoWriteOff'},
        {title: '预订金额', dataIndex: 'dealerPreOrderTotalAmount'},
        {title: '付款未核销', dataIndex: 'dealerReceiptNoWriteOffAmountTotal'},
        {title: '剩余额度', dataIndex: 'dealerSpareCreditLimit'},
    ]

    const extSearchColumns: StandardColumnsType = [
        {
            dataIndex: 'dealer',
            title: '客户编号/名称',
            search: {
                colSpan: 8
            }
        }
    ];

    return (
        <PageHeaderLayout>
            <StandardTable columns={columns} search={search} form={form} extSearchColumns={extSearchColumns}
                           rowKey={'id'} {...tableProps} />
        </PageHeaderLayout>
    )

}
